import React from 'react';
import qs from 'qs';
import { getApiUrlByName } from 'project/helpers';
import { apiNames } from 'project/general';
import { baseApi } from 'project/api';
import { EcommerceTracking, gtmService } from 'project/services';
import { ArrayHelper } from 'foundation/helpers';
import ProductListLayout from './product-list-layout';
import { sortTypes } from './enums';


const PRODUCT_LIST_PATH = getApiUrlByName(apiNames.PRODUCT_LIST);
const parsedUrl = qs.parse(window.location.search, { ignoreQueryPrefix: true });

class ProductListController extends React.Component {
    constructor(props) {
        super(props);
        const urlState = ProductListController.getStateFromBrowserAddress();
        const propsState = ProductListController.getInitialStateFromProps(props);
        const emptyState = {
            products: null,
            filters: {
                categories: this.selectedCategories
            },
            sorting: sortTypes[0],
            pagination: {
                current: 1,
            },
            pager: null,
            isLoading: false
        };
        this.state = {
            ...emptyState,
            ...urlState,
            ...propsState
        };
        this.cardsRef = React.createRef();
    }

    componentDidMount() {
        const { items } = this.props.products;

        ProductListController.trackProductImpression(items);
    }

    fetchProducts = () => {
        const { filters, pagination, sorting } = this.state;
        const queryString = {
            categories: filters.categories,
            page: pagination.current,
            sort: sorting.id
        };
        ProductListController.updateBrowserAddress(qs.stringify(queryString));
        queryString.path = this.props.productsRoot;
        const url = PRODUCT_LIST_PATH + '?' + qs.stringify(queryString);

        this.setState({
            isLoading: true
        });

        baseApi
            .get(url)
            .then((res) => {
                if (!res.data.success) return;

                const { data } = res.data;

                this.setState({
                    products: data.items,
                    pager: data.pager,
                    isLoading: false
                });
                ProductListController.trackProductImpression(data.items);
            })
            .catch((err) => {
                console.log(err);
            });
        //this.cardsRef.current.focus();
    };

    selectPage = (pageIndex) => {
        this.setState({
            pagination: {
                current: pageIndex,
            }
        }, this.fetchProducts);
    };

    selectCategories = (selectedCategories) => {
        this.trackFilter(selectedCategories);
        this.setState({
            filters: {
                categories: selectedCategories
            },
            pagination: {
                current: 1,
            }
        }, this.fetchProducts);
    };

    selectSorting = (sortType) => {
        this.setState({
            sorting: sortType,
            pagination: {
                current: 1,
            }
        }, this.fetchProducts);
    };

    trackFilter(selectedCategories) {
        const categoryNames = this.getCategotyNames(selectedCategories);
        gtmService.pushEvent('Product Filter', 'Filter', categoryNames.join(', '));
    }

    getCategotyNames(selectedCategories) {
        const result = [];

        selectedCategories.forEach((categoryId) => {
            const item = this.props.categories[ArrayHelper.findIndexByProp(this.props.categories, 'categoryId', categoryId)];
            if (item) {
                result.push(item.categoryName);
            }
        });
        return result;
    }

    static trackProductImpression(products) {
        if (products !== null && products.length > 0) {
            const trackingProducts = products.map((product) => product.trackingProduct);
            EcommerceTracking.trackImpression(trackingProducts);
        }
    }

    static updateBrowserAddress(queryString) {
        window.history.replaceState({}, document.title, `?${queryString}`);
    }

    static getStateFromBrowserAddress() {
        const state = {
            filters: {
                categories: []
            }
        };
        if (parsedUrl.sort) {
            state.sorting = sortTypes[ArrayHelper.findIndexByProp(sortTypes, 'id', parsedUrl.sort)];
        }

        if (parsedUrl.categories) {
            state.filters.categories = parsedUrl.categories.map((x) => window.parseInt(x, 10));
        }

        return state;
    }

    static getInitialStateFromProps(props) {
        const { items, pager } = props.products;
        return {
            products: items,
            pager
        };
    }

    render() {
        return (
            <ProductListLayout
                products={this.state.products}
                productsRoot={this.props.productsRoot}
                categories={this.props.categories}
                selectedCategories={this.state.filters.categories}
                sortTypes={sortTypes}
                filters={this.state.filters}
                sorting={this.state.sorting}
                pager={this.state.pager}
                selectCategories={this.selectCategories}
                selectSorting={this.selectSorting}
                selectPage={this.selectPage}
                isLoading={this.state.isLoading}
                showTitleFlag={this.props.showTitleFlag}
            />
        );
    }
}

export default ProductListController;
